// 导出文件
const exportFiles = (url: any, origin?: string) => {
  if (url.indexOf('http://') !== -1 || url.indexOf('https://') !== -1) {
    url = url;
  } else {
    origin = origin || location.origin;
    url = origin + url;
  }
  const oIfm = document.createElement('iframe');
  oIfm.style.cssText = 'position:fixed;left:0;top:0;width:1px;height:1px;z-index:-99;opacity:0;';
  // onload事件一般不管用，下载文件时chrome不触发
  oIfm.onload = function() {
    const I: any = this;
    setTimeout(() => {
      if (I.parentNode) {
        I.parentNode.removeChild(I);
      }
    }, 5000);
  };
  oIfm.setAttribute('src', url);
  document.body.appendChild(oIfm);
};
// 格式化url
const formatUrl = (oOption: any, url: string) => {
  const origin = window.location.origin;
  const absoluteUrl = origin + url;
  oOption = oOption || {};
  const i = absoluteUrl.indexOf('#');
  let sUrl = absoluteUrl.substring(0, i === -1 ? absoluteUrl.length : i);
  const sHash = i === -1 ? '' : absoluteUrl.substring(i);
  for (const attr in oOption) {
    if (oOption.hasOwnProperty(attr)) {
      const re = new RegExp('([\\?|&]' + attr + '=)[^&]*', 'igm');
      if (re.test(sUrl)) {
        sUrl = sUrl.replace(re, '$1' + encodeURI(oOption[attr]));
      } else {
        sUrl = sUrl.replace(/(\?+|&+)$/, '');
        const and = sUrl.indexOf('?') === -1 ? '?' : '&';
        sUrl += and + attr + '=' + oOption[attr];
      }
    }
  }
  return sUrl + sHash;
};
// post导出方法
const exportPostFiles = (data: Blob, name: string) => {
  const blob = new Blob([data], {
    type: 'application/zip'
  });
  const fileName = name;
  if ('download' in document.createElement('a') && (navigator as any).userAgent.indexOf('Edge') === -1) {
    // 非ie
    const ele = document.createElement('a');
    ele.download = fileName;
    ele.style.display = 'none';
    ele.href = URL.createObjectURL(blob);
    document.body.appendChild(ele);
    ele.click();
    URL.revokeObjectURL(ele.href);
    document.body.removeChild(ele);
  } else {
    // ie
    navigator.msSaveBlob(blob, fileName);
  }
};
export {
  exportFiles,
  formatUrl,
  exportPostFiles
};
